import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import notify_service from "@/services/notify_service";
import auth_service from "@/services/auth_service";
import {
  EcoFilialNodeFacilitiesTreeMap,
  EcoFilialNodeMapType,
  EcoFilialNodesFlatType,
  EcoObjectType,
  FilialNodeTree, FilialNodeTreeExtended,
  IObjectLifetimeMap,
  ResponseList, YearType
} from "@/services/models-service";
import {FillBlockShowResponse} from "@/services/fill-blocks-service";

const route_ns = `dicts/eco_objects`;

class EcoObjectsService {

  data_source = base_ds.getBaseDataSource(route_ns);
  public crud = base_ds.getBaseCrud(route_ns);
  // дерево "филиалы - тепловые узлы"
  public filialNodesTree: FilialNodeTree = {};
  public filialNodesFacilitiesTree: EcoFilialNodeFacilitiesTreeMap = {};

  public facilityLifetimeMap: IObjectLifetimeMap = {};

  constructor() {
    //
  }

  async update_cache() {
    if (auth_service.getToken().length === 0) {
      return
    }

    // "прогрев" кэша объектов ЕСО на бэке
    try {
      await this.crud.get();
    } catch (e) {
      notify_service.error(`Ошибка запроса обновления кэша ЕСО: ${e}`)
    }
  }

  async get_filials(eco_version: number | null, year: number | null = null, months: number[] | null = null): Promise<IResponseResult<EcoObjectType[]>> {
    // получение списка филиалов по фильтру
    try {
      const data = {
        version_id: eco_version,
        year: year,
        months: months,
      }

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/filials`,
        method: 'post',
        data: data,
      });

      if (resp?.data) {
        return { data: resp.data }
      } else {
        throw new Error('Получен пустой список');
      }
    } catch (e) {
      notify_service.error(`Ошибка запроса списка филиалов ЕСО: ${e}`);
      return { data: null };
    }
  }

  async get_filial_nodes_flat(eco_version: number | null, year: number | null = null, months: number[] | null = null): Promise<IResponseResult<EcoFilialNodesFlatType[]>> {
    // получение "плоского" списка филиалов и их тепловых узлов
    try {

      const data = {
        version_id: eco_version,
        year: year,
        months: months,
      }

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/filial_nodes_flat`,
        method: 'post',
        data: data,
      });

      if (resp) {
        return { data: resp }
      } else {
        throw new Error('Получен пустой список');
      }
    } catch (e) {
      notify_service.error(`Ошибка запроса списка филиалов и тепловых узлов ЕСО: ${e}`);
      return { data: null };
    }
  }

  async get_merged_all_heat_nodes(): Promise<IResponseResult<EcoObjectType[]>> {
    // получение списка тепловых узлов, смерженных по всем версиям и срокам жизни
    try {

      const resp: AxiosResponse["data"] = await  request({
        url: `${route_ns}/all_merged_heat_nodes`,
        method: 'post',
        data: {}
      });

      if (resp?.data) {
        return { data: resp.data }
      } else {
        throw new Error('Получен пустой список');
      }

    } catch (e) {
      notify_service.error(`Ошибка запроса списка теловых узлов ЕСО: ${e}`);
      return { data: null };
    }
  }

  async get_heat_nodes(eco_version: number | null, filial_id: number | null = null,
                       year: number | null = null, months: number[] | null = null, filial_ids: number[] | null = null): Promise<IResponseResult<EcoObjectType[]>> {
    // получение списка тепловых узлов по фильтру
    try {
      const data = {
        version_id: eco_version,
        parent_id: filial_id,
        parent_ids: filial_ids,
        year: year,
        months: months,
      }

      const resp: AxiosResponse["data"] = await  request({
        url: `${route_ns}/heat_nodes`,
        method: 'post',
        data: data,
      });

      if (resp?.data) {
        return { data: resp.data }
      } else {
        throw new Error('Получен пустой список');
      }

    } catch (e) {
      notify_service.error(`Ошибка запроса списка теловых узлов ЕСО: ${e}`);
      return { data: null };
    }
  }

  async get_facilities(eco_version: number,
                       parent_id: number | null = null,
                       parent_ids: number[] | null = null,
                       year: number, months: number[]): Promise<IResponseResult<EcoObjectType[]>> {
    // получение списка объектов по фильтру
    try {
      const data = {
        version_id: eco_version,
        parent_id: parent_id,
        parent_ids: parent_ids,
        year: year,
        months: months,
      }

      const resp = await  request({
        url: `${route_ns}/facilities`,
        method: 'post',
        data: data,
      });

      if (resp?.data) {
        return { data: resp.data }
      } else {
        throw new Error('Получен пустой список');
      }

    } catch (e) {
      notify_service.error(`Ошибка запроса списка объектов ЕСО: ${e}`);
      return { data: null };
    }
  }

  public async checkAcceptStatus(id_cut: string, year: string) {
    const url = `${route_ns}/check?filter=[["id_cut","=","${id_cut}"], "and", ["id_year", "=", "${year}"]]`;
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response) {
      result = response;
    }
    return result;
  }

  // запросить дерево "филиалы - тепловые узлы"
  public async get_filial_nodes_tree(eco_version: number | null, year: number | null = null, months: number[] | null = null): Promise<IResponseResult<FilialNodeTree>> {
    try {

      const data = {
        version_id: eco_version,
        parent_id: null,
        year: year,
        months: months,
      }

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/filial_nodes_tree`,
        method: 'post',
        data: data,
      });

      if (resp) {
        return {data: resp}
      } else {
        throw new Error('Получено пустое дерево "филиалы - тепловые узлы"');
      }
    } catch (e) {
      notify_service.error(`Ошибка запроса списка объектов ЕСО: ${e}`);
      return { data: null };
    }
  }

  public async filial_nodes_tree_extended(eco_version: number | null, year: number | null = null, months: number[] | null = null): Promise<IResponseResult<FilialNodeTreeExtended>> {
    try {

      const data = {
        version_id: eco_version,
        parent_id: null,
        year: year,
        months: months,
      }

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/filial_nodes_tree_extended`,
        method: 'post',
        data: data,
      });

      if (resp) {
        return {data: resp}
      } else {
        throw new Error('Получено пустое дерево "филиалы - тепловые узлы"');
      }
    } catch (e) {
      notify_service.error(`Ошибка запроса списка объектов ЕСО: ${e}`);
      return { data: null };
    }
  }

  // обновление состояния дерева "филиалы - тепловые узлы"
  public async update_filial_nodes_tree(eco_version: number | null, year: number | null = null, months: any[] | null = null): Promise<boolean> {

    if (!eco_version || !year) {
      return false
    }

    const response = await this.get_filial_nodes_tree(eco_version, year, months);
    if (response.data) {
      this.filialNodesTree = response.data;
      return true;
    }
    return false;
  }

  // Получить маппинг месяцев, в которых объект существовал
  async check_object_lifetime(eco_version: number, year_id: string, heat_node_id: number, _object_ids: number[]): Promise<IObjectLifetimeMap> {
    let object_ids = _object_ids.filter( id => !this.facilityLifetimeMap.hasOwnProperty(id));
    if (object_ids.length) {
      try {

        const resp: AxiosResponse["data"] = await request({
          url: `${route_ns}/facilities_lifetime`,
          method: 'post',
          data: { eco_version, year_id, heat_node_id, object_ids }
        });

        if (resp) {
          this.facilityLifetimeMap = { ...this.facilityLifetimeMap, ...resp }
        } else {
          throw new Error('Получен пустой список');
        }

      } catch (e) {
        notify_service.error(`Ошибка запроса объекта ЕСО: ${e}`);
        return {};
      }
    }
    return this.facilityLifetimeMap;
  }

  async get_facilities_tree(version_id: number, year: number, months: number[]): Promise<EcoFilialNodeFacilitiesTreeMap |  null> {
    // Чтение полного дерева  филиалы - тепловые узлы - объекты по версии ЕСО, году и месяцам
    try {

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/facilities_tree`,
        method: 'post',
        data: { version_id, year, months },
      });
      if (resp) {
        return resp;
      } else {
        throw new Error('Получен пустой список');
      }
    } catch (e) {
      notify_service.error(`Ошибка запроса связей тепловых узлов с филиалами ЕСО: ${e}`);
      return null;
    }
  }

  // обновление состояния дерева "филиалы - тепловые узлы"
  public async update_filial_facilities_tree(eco_version: number | null, year: number, months: number[]): Promise<boolean> {

    if (!eco_version || !year) {
      return false
    }

    const response = await this.get_facilities_tree(eco_version, year, months);
    if (response) {
      this.filialNodesFacilitiesTree = response;
      return true;
    }
    return false;
  }

  async get_filials_w_users(): Promise<IResponseResult<EcoObjectType[]>> {
    // получение списка филиалов c пользователями по фильтру
    try {

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/filials_w_users`,
        method: 'get',
      });

      if (resp?.data) {
        return { data: resp.data }
      } else {
        throw new Error('Получен пустой список');
      }
    } catch (e) {
      notify_service.error(`Ошибка запроса списка филиалов ЕСО с пользователями: ${e}`);
      return { data: null };
    }
  }

  empty() {

  }

}

export default new EcoObjectsService();
